import React, { useEffect, useState } from "react";
import { Button, Box } from "@mui/material";
import { useTranslation } from "react-i18next";

type KeypadProps = {
  onCodeChange: (code: string) => void;
};

const Keypad: React.FC<KeypadProps> = ({onCodeChange}) => {
  const [numbers, setNumbers] = useState<number[]>([]);
  const [input, setInput] = useState<number[]>([]);
  const {t}= useTranslation()

  // Mélange aléatoire des chiffres
  const shuffleNumbers = () => {
    const nums = Array.from({ length: 10 }, (_, i) => i);
    for (let i = nums.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [nums[i], nums[j]] = [nums[j], nums[i]];
    }
    return nums;
  };

  useEffect(() => {
    setNumbers(shuffleNumbers());
  }, []);

   const handleDigitClick = (num: number) => {
    if (input.length < 4) {
      const newInput = [...input, num];
      setInput(newInput);
      const code = newInput.join("");
      onCodeChange(code);
    }
  };

  const handleClear = () => {
    setInput([]);
    onCodeChange("");
  };


  return (
    <Box sx={{ width: 300, margin: "auto", textAlign: "center" }}>
      
      <Box
        display="flex"
        justifyContent="center"
        gap={2}
        mb={2}
        mt={2}
      >
        {[0, 1, 2, 3].map((index) => (
          <Box
            key={index}
            sx={{
              width: 12,
              height: 12,
              borderRadius: "50%",
              backgroundColor: index < input.length ? "#000" : "#ccc",
              transition: "background-color 0.2s",
            }}
          />
        ))}
      </Box>

      {/* <Grid container spacing={1}>
        {numbers.map((number) => (
          <Grid item xs={4} key={number}>
            <Button
              variant="outlined"
              style={{
                width: "100%",
                height: 50,
                fontSize: 24,
                borderColor: "#000000",
                color: "#000000",
              }}
              onClick={() => handleDigitClick(number)}
            >
              {number}
            </Button>
          </Grid>
        ))}

        <Grid item xs={4}>
          <Button
            variant="outlined"
            style={{
              width: "100%",
              height: 50,
              fontSize: 24,
              borderColor: "#000000",
              color: "#000000",
            }}
            onClick={handleClear}
          >
            {t("clear")}
          </Button>
        </Grid>
      </Grid> */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: '8px'
      }}>
        {numbers.map((number) => (
          <Button
            key={number}
            variant="outlined"
            style={{
              width: "100%",
              height: 50,
              fontSize: 24,
              borderColor: "#000000",
              color: "#000000",
            }}
            onClick={() => handleDigitClick(number)}
          >
            {number}
          </Button>
        ))}

        <Button
          variant="outlined"
          style={{
            width: "100%",
            height: 50,
            fontSize: 24,
            borderColor: "#000000",
            color: "#000000",
          }}
          onClick={handleClear}
        >
          {t("clear")}
        </Button>
      </div>
    </Box>
  );
};

export default Keypad;
